import React from 'react'

import { IconPropsType } from '../types'

const FirefoxBrowserIcon = (props: IconPropsType) => {
   const { width = 28, height = 28, ...rest } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         viewBox='0 0 28 28'
         fill='none'
         {...rest}
      >
         <g clip-path='url(#clip0_9788_773)'>
            <path
               d='M26.5706 9.3904C25.9812 7.9722 24.7856 6.44095 23.8494 5.9569C24.5172 7.25019 24.9806 8.63912 25.2231 10.0743L25.2256 10.097C23.6919 6.2733 21.091 4.73155 18.9669 1.37435C18.8594 1.2046 18.752 1.0345 18.6473 0.854947C18.5875 0.752397 18.5395 0.659997 18.4979 0.574947C18.4098 0.40434 18.3419 0.224038 18.2956 0.0376966C18.2956 0.0290979 18.2925 0.0207772 18.2868 0.0143219C18.2812 0.0078665 18.2733 0.00372829 18.2648 0.00269664C18.2564 0.000403204 18.2476 0.000403204 18.2392 0.00269664C18.2375 0.00269664 18.2347 0.00584664 18.2326 0.00654664C18.2305 0.00724664 18.2259 0.0103966 18.2228 0.0117966L18.228 0.00269664C14.8208 1.9977 13.6647 5.6909 13.5583 7.5382C12.1976 7.63173 10.8967 8.13315 9.82522 8.97705C9.71343 8.88236 9.59659 8.79379 9.47522 8.71175C9.16613 7.62988 9.15296 6.48489 9.43707 5.3962C8.1858 6.00237 7.07396 6.86166 6.17192 7.9197H6.16562C5.62802 7.23825 5.66582 4.99125 5.69662 4.5219C5.53758 4.58581 5.38576 4.66641 5.24372 4.76235C4.76913 5.10106 4.32547 5.48113 3.91792 5.8981C3.4535 6.36896 3.02934 6.87789 2.64987 7.41955V7.42165V7.4192C1.77775 8.65559 1.15918 10.0525 0.829867 11.5292L0.811667 11.6188C0.786117 11.7382 0.694067 12.336 0.678317 12.4658C0.678317 12.476 0.676217 12.4854 0.675167 12.4956C0.556425 13.1128 0.482847 13.7378 0.455017 14.3656V14.4356C0.457991 17.8321 1.73498 21.104 4.0336 23.6045C6.33222 26.105 9.48522 27.6523 12.8695 27.9405C16.2537 28.2287 19.623 27.2369 22.3113 25.1612C24.9997 23.0854 26.8116 20.0766 27.3889 16.7295C27.4117 16.5545 27.4302 16.3813 27.4505 16.2045C27.7299 13.8953 27.4274 11.5529 26.5706 9.3904ZM10.9361 20.0087C10.9995 20.0391 11.059 20.072 11.1241 20.1011L11.1335 20.107C11.0677 20.0755 11.0019 20.0428 10.9361 20.0087ZM25.2266 10.1002V10.0872L25.2291 10.1016L25.2266 10.1002Z'
               fill='url(#paint0_linear_9788_773)'
            />
            <path
               d='M26.5706 9.39053C25.9812 7.97233 24.7856 6.44108 23.8494 5.95703C24.5172 7.25032 24.9806 8.63926 25.2231 10.0744V10.0874L25.2256 10.1017C26.2711 13.0937 26.1199 16.374 24.8035 19.257C23.2488 22.5929 19.4856 26.012 13.5951 25.8458C7.23032 25.6655 1.62507 20.9426 0.577167 14.7567C0.386417 13.7813 0.577167 13.2867 0.673067 12.494C0.542247 13.1098 0.469246 13.7364 0.455017 14.3658V14.4358C0.457991 17.8323 1.73498 21.1041 4.0336 23.6046C6.33222 26.1051 9.48522 27.6524 12.8695 27.9406C16.2537 28.2289 19.623 27.2371 22.3113 25.1613C24.9997 23.0855 26.8116 20.0768 27.3889 16.7297C27.4117 16.5547 27.4302 16.3814 27.4505 16.2047C27.7299 13.8955 27.4274 11.553 26.5706 9.39053Z'
               fill='url(#paint1_radial_9788_773)'
            />
            <path
               d='M26.5706 9.39053C25.9812 7.97233 24.7856 6.44108 23.8494 5.95703C24.5172 7.25032 24.9806 8.63926 25.2231 10.0744V10.0874L25.2256 10.1017C26.2711 13.0937 26.1199 16.374 24.8035 19.257C23.2488 22.5929 19.4856 26.012 13.5951 25.8458C7.23032 25.6655 1.62507 20.9426 0.577167 14.7567C0.386417 13.7813 0.577167 13.2867 0.673067 12.494C0.542247 13.1098 0.469246 13.7364 0.455017 14.3658V14.4358C0.457991 17.8323 1.73498 21.1041 4.0336 23.6046C6.33222 26.1051 9.48522 27.6524 12.8695 27.9406C16.2537 28.2289 19.623 27.2371 22.3113 25.1613C24.9997 23.0855 26.8116 20.0768 27.3889 16.7297C27.4117 16.5547 27.4302 16.3814 27.4505 16.2047C27.7299 13.8955 27.4274 11.553 26.5706 9.39053Z'
               fill='url(#paint2_radial_9788_773)'
            />
            <path
               d='M19.9787 10.9852C20.0081 11.0059 20.0354 11.0265 20.063 11.0472C19.7223 10.443 19.2981 9.88979 18.803 9.40393C14.5869 5.18713 17.6981 0.26088 18.2227 0.0106297L18.228 0.00292969C14.8207 1.99793 13.6647 5.69113 13.5583 7.53843C13.7165 7.52758 13.8733 7.51428 14.035 7.51428C15.244 7.51649 16.4308 7.83882 17.4748 8.44848C18.5188 9.05814 19.3827 9.93339 19.9787 10.9852Z'
               fill='url(#paint3_radial_9788_773)'
            />
            <path
               d='M14.0437 11.8277C14.0213 12.1651 12.8292 13.3288 12.4124 13.3288C8.55504 13.3288 7.92889 15.6623 7.92889 15.6623C8.09969 17.6272 9.46889 19.2456 11.124 20.1017C11.1996 20.1409 11.2763 20.1762 11.3529 20.2109C11.4857 20.2697 11.6185 20.3241 11.7512 20.374C12.3193 20.575 12.9142 20.6898 13.5163 20.7145C20.2772 21.0316 21.5869 12.6295 16.7079 10.1914C17.8589 10.0417 19.0245 10.3247 19.9787 10.9856C19.3827 9.93376 18.5188 9.05851 17.4748 8.44885C16.4308 7.83919 15.244 7.51686 14.035 7.51465C13.874 7.51465 13.7165 7.52795 13.5583 7.5388C12.1976 7.63233 10.8967 8.13375 9.82519 8.97765C10.032 9.15265 10.2655 9.38645 10.7572 9.8712C11.6777 10.778 14.0385 11.7174 14.0437 11.8277Z'
               fill='url(#paint4_radial_9788_773)'
            />
            <path
               d='M14.0437 11.8277C14.0213 12.1651 12.8292 13.3288 12.4124 13.3288C8.55504 13.3288 7.92889 15.6623 7.92889 15.6623C8.09969 17.6272 9.46889 19.2456 11.124 20.1017C11.1996 20.1409 11.2763 20.1762 11.3529 20.2109C11.4857 20.2697 11.6185 20.3241 11.7512 20.374C12.3193 20.575 12.9142 20.6898 13.5163 20.7145C20.2772 21.0316 21.5869 12.6295 16.7079 10.1914C17.8589 10.0417 19.0245 10.3247 19.9787 10.9856C19.3827 9.93376 18.5188 9.05851 17.4748 8.44885C16.4308 7.83919 15.244 7.51686 14.035 7.51465C13.874 7.51465 13.7165 7.52795 13.5583 7.5388C12.1976 7.63233 10.8967 8.13375 9.82519 8.97765C10.032 9.15265 10.2655 9.38645 10.7572 9.8712C11.6777 10.778 14.0385 11.7174 14.0437 11.8277Z'
               fill='url(#paint5_radial_9788_773)'
            />
            <path
               d='M9.19273 8.52618C9.30263 8.59618 9.39328 8.65708 9.47273 8.71203C9.16365 7.63016 9.15047 6.48518 9.43458 5.39648C8.18331 6.00266 7.07148 6.86195 6.16943 7.91998C6.23558 7.91823 8.20328 7.88288 9.19273 8.52618Z'
               fill='url(#paint6_radial_9788_773)'
            />
            <path
               d='M0.578929 14.7566C1.62578 20.9425 7.23208 25.6654 13.5968 25.8456C19.4873 26.0122 23.2505 22.5927 24.8052 19.2569C26.1216 16.3738 26.2729 13.0936 25.2273 10.1016V10.0886C25.2273 10.0785 25.2252 10.0725 25.2273 10.0757L25.2298 10.0984C25.711 13.2404 24.1129 16.2843 21.6146 18.3427L21.6069 18.3602C16.7391 22.3246 12.0806 20.7521 11.1377 20.1102C11.0719 20.0787 11.0061 20.0459 10.9403 20.0118C8.10218 18.6552 6.92968 16.0694 7.18098 13.8518C6.50727 13.8618 5.84513 13.6761 5.27479 13.3174C4.70445 12.9586 4.25039 12.4422 3.96763 11.8306C4.71264 11.3742 5.56213 11.1161 6.43514 11.0811C7.30814 11.0461 8.17558 11.2352 8.95478 11.6304C10.5612 12.3597 12.3892 12.4315 14.048 11.8306C14.0427 11.7203 11.682 10.7806 10.7615 9.87409C10.2697 9.38934 10.0363 9.15589 9.82943 8.98054C9.71764 8.88585 9.6008 8.79729 9.47943 8.71524C9.39893 8.66029 9.30828 8.60079 9.19943 8.52939C8.20998 7.88609 6.24228 7.92144 6.17718 7.92319H6.17088C5.63328 7.24174 5.67108 4.99474 5.70188 4.52539C5.54284 4.58931 5.39102 4.66991 5.24898 4.76584C4.77439 5.10456 4.33073 5.48462 3.92318 5.90159C3.4571 6.37113 3.03118 6.87889 2.64988 7.41954V7.42164V7.41919C1.77776 8.65559 1.15919 10.0525 0.829879 11.5292C0.823229 11.5569 0.341279 13.6639 0.578929 14.7566Z'
               fill='url(#paint7_radial_9788_773)'
            />
            <path
               d='M18.8038 9.4037C19.299 9.89009 19.7232 10.4439 20.0638 11.0487C20.1383 11.105 20.208 11.161 20.2671 11.2153C23.3426 14.0503 21.7312 18.0578 21.6111 18.343C24.1094 16.2847 25.7061 13.2407 25.2263 10.0988C23.6919 6.2733 21.091 4.73155 18.9669 1.37435C18.8594 1.2046 18.752 1.0345 18.6473 0.854947C18.5875 0.752397 18.5395 0.659997 18.4979 0.574947C18.4098 0.40434 18.3419 0.224038 18.2956 0.0376966C18.2956 0.0290979 18.2925 0.0207772 18.2869 0.0143219C18.2812 0.0078665 18.2733 0.00372829 18.2648 0.00269664C18.2564 0.000403204 18.2476 0.000403204 18.2392 0.00269664C18.2375 0.00269664 18.2347 0.00584664 18.2326 0.00654664C18.2305 0.00724664 18.2259 0.0103966 18.2228 0.0117966C17.6981 0.260647 14.587 5.1869 18.8038 9.4037Z'
               fill='url(#paint8_radial_9788_773)'
            />
            <path
               d='M20.265 11.2142C20.2058 11.16 20.1362 11.104 20.0616 11.0476C20.034 11.027 20.0067 11.0063 19.9773 10.9857C19.0231 10.3248 17.8575 10.0417 16.7065 10.1915C21.5855 12.631 20.2765 21.0317 13.5149 20.7146C12.9128 20.6899 12.3179 20.5751 11.7498 20.3741C11.6171 20.3244 11.4843 20.27 11.3515 20.211C11.2749 20.176 11.1982 20.141 11.1226 20.1018L11.1321 20.1077C12.075 20.7514 16.7321 22.3239 21.6013 18.3577L21.609 18.3402C21.7304 18.0567 23.3418 14.0482 20.265 11.2142Z'
               fill='url(#paint9_radial_9788_773)'
            />
            <path
               d='M7.92888 15.6624C7.92888 15.6624 8.55503 13.329 12.4124 13.329C12.8292 13.329 14.0224 12.1652 14.0437 11.8278C12.385 12.4288 10.557 12.3569 8.95053 11.6276C8.17133 11.2324 7.30389 11.0433 6.43089 11.0783C5.55788 11.1134 4.70839 11.3714 3.96338 11.8278C4.24614 12.4394 4.7002 12.9559 5.27054 13.3146C5.84088 13.6734 6.50302 13.859 7.17673 13.8491C6.92543 16.067 8.09793 18.6528 10.9361 20.0091C10.9994 20.0395 11.0589 20.0724 11.124 20.1015C9.46748 19.2457 8.09968 17.6273 7.92888 15.6624Z'
               fill='url(#paint10_radial_9788_773)'
            />
            <path
               d='M26.5706 9.3904C25.9812 7.9722 24.7856 6.44095 23.8494 5.9569C24.5172 7.25019 24.9806 8.63912 25.2231 10.0743L25.2256 10.097C23.6919 6.2733 21.091 4.73155 18.9669 1.37435C18.8594 1.2046 18.752 1.0345 18.6473 0.854947C18.5875 0.752397 18.5395 0.659997 18.4979 0.574947C18.4098 0.40434 18.3419 0.224038 18.2956 0.0376966C18.2956 0.0290979 18.2925 0.0207772 18.2868 0.0143219C18.2812 0.0078665 18.2733 0.00372829 18.2648 0.00269664C18.2564 0.000403204 18.2476 0.000403204 18.2392 0.00269664C18.2375 0.00269664 18.2347 0.00584664 18.2326 0.00654664C18.2305 0.00724664 18.2259 0.0103966 18.2228 0.0117966L18.228 0.00269664C14.8208 1.9977 13.6647 5.6909 13.5583 7.5382C13.7165 7.52735 13.8733 7.51405 14.035 7.51405C15.244 7.51626 16.4308 7.83859 17.4748 8.44825C18.5188 9.05791 19.3827 9.93316 19.9787 10.985C19.0246 10.3241 17.859 10.0411 16.708 10.1908C21.587 12.6303 20.278 21.031 13.5163 20.7139C12.9143 20.6892 12.3193 20.5744 11.7513 20.3734C11.6185 20.3237 11.4857 20.2693 11.353 20.2103C11.2763 20.1753 11.1997 20.1403 11.1241 20.1011L11.1335 20.107C11.0677 20.0755 11.0019 20.0428 10.9361 20.0087C10.9995 20.0391 11.059 20.072 11.1241 20.1011C9.46752 19.245 8.09972 17.6266 7.92892 15.6617C7.92892 15.6617 8.55507 13.3282 12.4124 13.3282C12.8293 13.3282 14.0224 12.1645 14.0438 11.8271C14.0385 11.7168 11.6778 10.7771 10.7573 9.8706C10.2655 9.38585 10.0321 9.1524 9.82522 8.97705C9.71343 8.88236 9.59659 8.79379 9.47522 8.71175C9.16613 7.62988 9.15296 6.48489 9.43707 5.3962C8.1858 6.00237 7.07396 6.86166 6.17192 7.9197H6.16562C5.62802 7.23825 5.66582 4.99125 5.69662 4.5219C5.53758 4.58581 5.38576 4.66641 5.24372 4.76235C4.76913 5.10106 4.32547 5.48113 3.91792 5.8981C3.4535 6.36896 3.02934 6.87789 2.64987 7.41955V7.42165V7.4192C1.77775 8.65559 1.15918 10.0525 0.829867 11.5292L0.811667 11.6188C0.786117 11.7382 0.671667 12.3444 0.655217 12.4746C0.655217 12.4644 0.655217 12.4844 0.655217 12.4746C0.550536 13.1004 0.483681 13.7318 0.455017 14.3656V14.4356C0.457991 17.8321 1.73498 21.104 4.0336 23.6045C6.33222 26.105 9.48522 27.6523 12.8695 27.9405C16.2537 28.2287 19.623 27.2369 22.3113 25.1612C24.9997 23.0854 26.8116 20.0766 27.3889 16.7295C27.4117 16.5545 27.4302 16.3813 27.4505 16.2045C27.7299 13.8953 27.4274 11.5529 26.5706 9.3904Z'
               fill='url(#paint11_linear_9788_773)'
            />
         </g>
         <defs>
            <linearGradient
               id='paint0_linear_9788_773'
               x1='24.7751'
               y1='4.3371'
               x2='2.25647'
               y2='26.0633'
               gradientUnits='userSpaceOnUse'
            >
               <stop offset='0.048' stop-color='#FFF44F' />
               <stop offset='0.111' stop-color='#FFE847' />
               <stop offset='0.225' stop-color='#FFC830' />
               <stop offset='0.368' stop-color='#FF980E' />
               <stop offset='0.401' stop-color='#FF8B16' />
               <stop offset='0.462' stop-color='#FF672A' />
               <stop offset='0.534' stop-color='#FF3647' />
               <stop offset='0.705' stop-color='#E31587' />
            </linearGradient>
            <radialGradient
               id='paint1_radial_9788_773'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(23.7346 3.10733) scale(28.2789 28.279)'
            >
               <stop offset='0.129' stop-color='#FFBD4F' />
               <stop offset='0.186' stop-color='#FFAC31' />
               <stop offset='0.247' stop-color='#FF9D17' />
               <stop offset='0.283' stop-color='#FF980E' />
               <stop offset='0.403' stop-color='#FF563B' />
               <stop offset='0.467' stop-color='#FF3750' />
               <stop offset='0.71' stop-color='#F5156C' />
               <stop offset='0.782' stop-color='#EB0878' />
               <stop offset='0.86' stop-color='#E50080' />
            </radialGradient>
            <radialGradient
               id='paint2_radial_9788_773'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(13.4012 14.6685) scale(28.2789 28.279)'
            >
               <stop offset='0.3' stop-color='#960E18' />
               <stop offset='0.351' stop-color='#B11927' stop-opacity='0.74' />
               <stop offset='0.435' stop-color='#DB293D' stop-opacity='0.343' />
               <stop offset='0.497' stop-color='#F5334B' stop-opacity='0.094' />
               <stop offset='0.53' stop-color='#FF3750' stop-opacity='0' />
            </radialGradient>
            <radialGradient
               id='paint3_radial_9788_773'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(16.8105 -3.31017) scale(20.4869 20.4869)'
            >
               <stop offset='0.132' stop-color='#FFF44F' />
               <stop offset='0.252' stop-color='#FFDC3E' />
               <stop offset='0.506' stop-color='#FF9D12' />
               <stop offset='0.526' stop-color='#FF980E' />
            </radialGradient>
            <radialGradient
               id='paint4_radial_9788_773'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(10.2732 22.0557) scale(13.4649 13.4648)'
            >
               <stop offset='0.353' stop-color='#3A8EE6' />
               <stop offset='0.472' stop-color='#5C79F0' />
               <stop offset='0.669' stop-color='#9059FF' />
               <stop offset='1' stop-color='#C139E6' />
            </radialGradient>
            <radialGradient
               id='paint5_radial_9788_773'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(14.9465 12.3514) rotate(-13.5916) scale(7.13898 8.35797)'
            >
               <stop offset='0.206' stop-color='#9059FF' stop-opacity='0' />
               <stop offset='0.278' stop-color='#8C4FF3' stop-opacity='0.064' />
               <stop offset='0.747' stop-color='#7716A8' stop-opacity='0.45' />
               <stop offset='0.975' stop-color='#6E008B' stop-opacity='0.6' />
            </radialGradient>
            <radialGradient
               id='paint6_radial_9788_773'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(13.0441 1.95038) scale(9.6866)'
            >
               <stop stop-color='#FFE226' />
               <stop offset='0.121' stop-color='#FFDB27' />
               <stop offset='0.295' stop-color='#FFC82A' />
               <stop offset='0.502' stop-color='#FFA930' />
               <stop offset='0.732' stop-color='#FF7E37' />
               <stop offset='0.792' stop-color='#FF7139' />
            </radialGradient>
            <radialGradient
               id='paint7_radial_9788_773'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(20.6581 -4.19381) scale(41.3284)'
            >
               <stop offset='0.113' stop-color='#FFF44F' />
               <stop offset='0.456' stop-color='#FF980E' />
               <stop offset='0.622' stop-color='#FF5634' />
               <stop offset='0.716' stop-color='#FF3647' />
               <stop offset='0.904' stop-color='#E31587' />
            </radialGradient>
            <radialGradient
               id='paint8_radial_9788_773'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(17.1747 -1.89586) rotate(83.976) scale(30.2905 19.8794)'
            >
               <stop stop-color='#FFF44F' />
               <stop offset='0.06' stop-color='#FFE847' />
               <stop offset='0.168' stop-color='#FFC830' />
               <stop offset='0.304' stop-color='#FF980E' />
               <stop offset='0.356' stop-color='#FF8B16' />
               <stop offset='0.455' stop-color='#FF672A' />
               <stop offset='0.57' stop-color='#FF3647' />
               <stop offset='0.737' stop-color='#E31587' />
            </radialGradient>
            <radialGradient
               id='paint9_radial_9788_773'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(12.8159 5.5386) scale(25.802 25.802)'
            >
               <stop offset='0.137' stop-color='#FFF44F' />
               <stop offset='0.48' stop-color='#FF980E' />
               <stop offset='0.592' stop-color='#FF5634' />
               <stop offset='0.655' stop-color='#FF3647' />
               <stop offset='0.904' stop-color='#E31587' />
            </radialGradient>
            <radialGradient
               id='paint10_radial_9788_773'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(19.6269 7.04893) scale(28.2401 28.2401)'
            >
               <stop offset='0.094' stop-color='#FFF44F' />
               <stop offset='0.231' stop-color='#FFE141' />
               <stop offset='0.509' stop-color='#FFAF1E' />
               <stop offset='0.626' stop-color='#FF980E' />
            </radialGradient>
            <linearGradient
               id='paint11_linear_9788_773'
               x1='24.5046'
               y1='4.2209'
               x2='5.34346'
               y2='23.3816'
               gradientUnits='userSpaceOnUse'
            >
               <stop offset='0.167' stop-color='#FFF44F' stop-opacity='0.8' />
               <stop offset='0.266' stop-color='#FFF44F' stop-opacity='0.634' />
               <stop offset='0.489' stop-color='#FFF44F' stop-opacity='0.217' />
               <stop offset='0.6' stop-color='#FFF44F' stop-opacity='0' />
            </linearGradient>
            <clipPath id='clip0_9788_773'>
               <rect width='28' height='28' fill='white' />
            </clipPath>
         </defs>
      </svg>
   )
}

export default FirefoxBrowserIcon
